<template>
  <div class="absolute right-0px top-97px !h-[calc(100%-97px)] w-420px z-20 p-10px text-right">
  <div data-v-14b8093e="" class="absolute top-0px right-0 h-full w-300px right-bg-modal"></div>
  <div class="w-full h-full rounded-10px p-10px bg-[#051A22CC] ">
     <risk-operation-control class="h-9/25"></risk-operation-control>
     <class-meeting-execution class="h-8/25"></class-meeting-execution>
     <hidden-danger-treatment class="h-8/25"></hidden-danger-treatment>
  </div>
  </div>
</template>

<script>
import RiskOperationControl from './riskOperationControl.vue'
import ClassMeetingExecution from './classMeetingExecution.vue'
import HiddenDangerTreatment from './hiddenDangerTreatment.vue'

export default {
  name: 'LeftCom',
  props: [],
  components: { ClassMeetingExecution, RiskOperationControl, HiddenDangerTreatment },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
 .right-bg-modal {
  z-index: -1;
    background: linear-gradient(89.61deg, rgba(4, 18, 26, 0) 12.55%, rgba(4, 16, 23, .63) 55.92%, rgba(4, 17, 24, .9) 99.62%);
}
</style>
